

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Archive/Widget/index.tsx';
    import createController from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Archive/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'Archive';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643',
      id: '2062d0a4929b45348643784b5cb39c36',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Archive/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"archive-link.post-count":"({count, number}) ","archive-link.month-and-year-utc":"{time, date, monthAndYearUtc}","empty-state.no-posts":"No posts yet.","aria-label.archive":"Archive","archive-link.a11y-post-count":"{count, plural, one {# post} other {# posts}}","archive-link.a11y-post-count-plural":"{count, number} posts","app-settings.main-tab":"Main","app-settings.display-tab":"Display","app-settings.layout-tab":"Layout","app-settings.design-tab":"Design","app-settings.support-tab":"Support","support-tab.links-divider":"Got a question?","support-tab.read-support-articles-link":"Read Support Articles","support-tab.get-involved-text":"Get involved. Ask questions, get answers and share your thoughts with other bloggers.","support-tab.blog-community-link":"Blog Community","main-tab.title":"Archive","main-tab.description":"Display your past posts by month. Adjust the layout, customize the look & more.","main-tab.customize-design-button":"Customize","display-tab.show-newest-first-label":"Show newest posts first","display-tab.show-post-count-label":"Show number of posts","display-tab.months-display-limit-label":"Number of months displayed","display-tab.mobile.enable-settings-label":"Enable mobile settings","tab.mobile.settings-toggle-info-text":"If disabled, your display settings for mobile are taken from desktop. Turn on these settings to customize how your archive looks on mobile devices.","link-list-design-settings.text-color-label":"Font color","link-list-design-settings.text-font-and-color-label":"Font style & color","link-list-design-settings.background-color-label":"Background opacity & color","link-list-design-settings.separator-color-label":"Divider opacity & color","link-list-design-settings.separator-width-label":"Divider width","link-list-design-settings.border-color-label":"Border opacity & color","link-list-design-settings.border-width-label":"Border width","link-list-design-settings.corner-radius-label":"Corner radius","link-list-design-settings.default-state-tab":"Regular","link-list-design-settings.hover-state-tab":"Hover","link-list-layout-settings.text-alignment-label":"Text alignment","link-list-layout-settings.text-alignment-left":"Left","link-list-layout-settings.text-alignment-center":"Center","link-list-layout-settings.text-alignment-right":"Right","link-list-layout-settings.text-padding-horizontal-label":"Text side padding","link-list-layout-settings.text-padding-vertical-label":"Text top & bottom padding","support-tab.archive-widget.about.title":"Customizing an archive","support-tab.archive-widget.about.description":"Adding an archive to your blog is a great way to show older content that has been 'archived' or stored away in a blog.","support-tab.archive-widget.about.read-more":"Read More","support-tab.technical-assistant.description":"Technical problems? Troubleshoot common errors and issues.","support-tab.technical-assistant.link-label":"Wix Technical Assistant","support-tab.faq.description":"Find answers in the Blog Community FAQ.","support-tab.faq.link-label":"Frequently Asked Questions","support-tab.customer-care.description":"Still having issues? Contact us for assistance.","support-tab.customer-care.link-label":"Contact Customer Care","support-tab.help-center.label":"Help Center","support-tab.help-center.all-articles":"See All Articles","cssbp.indications-banner-label-cascades":"Changes will cascade to lower breakpoints.","cssbp.indications-help":"Learn more"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "2f3d2c69-2bc4-4519-bd72-0a63dd92577f";
    var localeDistPath = 'components/Archive/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
